import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import * as XLSX from 'xlsx';
import './AdminView.css';

const AdminView = () => {
  const [applications, setApplications] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
      if (user) {
        fetchApplications();
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchApplications = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'applications'));
      const applicationsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setApplications(applicationsData);
    } catch (error) {
      console.error('Error fetching applications:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu başvuruyu silmek istediğinizden emin misiniz?')) {
      try {
        await deleteDoc(doc(db, 'applications', id));
        alert('Başvuru başarıyla silindi');
        setApplications(applications.filter(app => app.id !== id));
      } catch (error) {
        console.error('Error deleting application:', error);
        alert('Başvuru silinirken bir hata oluştu');
      }
    }
  };

  // -------------------------------
  // TOPLU SİLME İŞLEVİ
  // -------------------------------
  const handleDeleteAll = async () => {
    const step1 = window.confirm("Tüm başvuruları silmek istediğinize emin misiniz?");
    if (!step1) return;

    const step2 = window.confirm("Bu işlem geri alınamaz! BÜTÜN başvurular kalıcı olarak silinecek. Devam edilsin mi?");
    if (!step2) return;

    try {
      const appsRef = collection(db, "applications");
      const snapshot = await getDocs(appsRef);

      let count = 0;

      const deletePromises = snapshot.docs.map((d) => {
        count++;
        return deleteDoc(doc(db, "applications", d.id));
      });

      await Promise.all(deletePromises);

      alert(`Toplam ${count} başvuru silindi.`);
      setApplications([]); // Listeyi sıfırla

    } catch (error) {
      console.error("Toplu silme hatası:", error);
      alert("Toplu silme sırasında bir hata oluştu.");
    }
  };
  // -------------------------------


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, loginData.email, loginData.password);
      setIsLoggedIn(true);
    } catch (error) {
      console.error('Error logging in:', error);
      alert('Geçersiz giriş bilgileri');
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsLoggedIn(false);
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const exportToExcel = () => {
    try {
      const data = applications.map((app, index) => [
        index + 1,
        app.firstName,
        app.lastName,
        app.phone,
        app.school,
        app.grade,
        new Date(app.submittedAt.toDate()).toLocaleString('tr-TR')
      ]);

      data.unshift(['No', 'Ad', 'Soyad', 'Telefon', 'Okul', 'Sınıf', 'Başvuru Tarihi']);

      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();

      const colWidths = [
        { wch: 5 }, 
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 30 },
        { wch: 10 },
        { wch: 20 }
      ];
      ws['!cols'] = colWidths;

      const range = XLSX.utils.decode_range(ws['!ref']);

      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          ws[cellRef].s = {
            border: {
              top: { style: 'thin', color: { rgb: '000000' } },
              bottom: { style: 'thin', color: { rgb: '000000' } },
              left: { style: 'thin', color: { rgb: '000000' } },
              right: { style: 'thin', color: { rgb: '000000' } }
            },
            alignment: {
              vertical: 'center',
              horizontal: 'center',
              wrapText: true
            },
            font: R === 0 ? { bold: true, sz: 12 } : { sz: 11 }
          };

          if (R === 0) {
            ws[cellRef].s.fill = {
              fgColor: { rgb: 'E0E0E0' },
              patternType: 'solid'
            };
          }
        }
      }

      XLSX.utils.book_append_sheet(wb, ws, 'Başvurular');
      XLSX.writeFile(wb, 'Akademi_Bursluluk_Basvurulari.xlsx');

    } catch (error) {
      console.error('Dışa aktarma hatası:', error);
      alert('Dışa aktarma sırasında bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="admin-login">
        <h2>Yönetici Girişi</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">E-posta</label>
            <input
              type="email"
              id="email"
              value={loginData.email}
              onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Şifre</label>
            <input
              type="password"
              id="password"
              value={loginData.password}
              onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
              required
            />
          </div>
          <button type="submit">Giriş Yap</button>
        </form>
      </div>
    );
  }

  return (
    <div className="admin-view">
      <div className="admin-header">
        <h2>Bursluluk Başvuruları</h2>
        <div className="admin-buttons">
          <button onClick={exportToExcel} className="export-button">Excel'e Aktar</button>

          {/* YENİ: Toplu Silme Butonu */}
          <button onClick={handleDeleteAll} className="delete-all-button">
            Tüm Başvuruları Sil
          </button>

          <button onClick={handleLogout} className="logout-button">Çıkış Yap</button>
        </div>
      </div>

      <div className="applications-list">
        {applications.map((application, index) => (
          <div key={application.id} className="application-card">
            <div className="card-header">
              <h3>#{index + 1} - {application.firstName} {application.lastName}</h3>
              <button 
                onClick={() => handleDelete(application.id)} 
                className="delete-button"
              >
                ×
              </button>
            </div>
            <p><strong>Telefon:</strong> {application.phone}</p>
            <p><strong>Okul:</strong> {application.school}</p>
            <p><strong>Sınıf:</strong> {application.grade}</p>
            <p><strong>Başvuru Tarihi:</strong> {new Date(application.submittedAt.toDate()).toLocaleString('tr-TR')}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminView;
